import {
  ColorObject,
  decomposeColor,
  recomposeColor,
} from '@mui/material/styles';

type RGBAColorValue = [number, number, number, number];

function normalizeAlpha({type, values}: ColorObject): RGBAColorValue {
  return type === 'rgb'
    ? [values[0], values[1], values[2], 1]
    : [values[0], values[1], values[2], values[3] as number];
}

export function overlayColor(baseColor: string, overlayColor: string): string {
  const base = normalizeAlpha(decomposeColor(baseColor));
  const add = normalizeAlpha(decomposeColor(overlayColor));
  const alpha = 1 - (1 - add[3]) * (1 - base[3]);

  const calcIndex = (i: number) =>
    Math.round(
      (add[i] * add[3]) / alpha + (base[i] * base[3] * (1 - add[3])) / alpha
    );

  return recomposeColor({
    type: 'rgba',
    values: [calcIndex(0), calcIndex(1), calcIndex(2), alpha],
  });
}
